import classNames from 'classnames';
import { memo } from 'react';
import Image from '@/common/Image';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useImageWithFallback from '~/hooks/common/ui/useImageWithFallback';
import useGetCondensedHeroImages, {
  ImageType
} from './hooks/useGetCondensedHeroImages';
import { useSpinnerWithAnalytics, useSwipeTracking } from '../hooks';

function VehicleImage() {
  const { year, make, model } = useGetVehicleDetails();
  const { heroImageMap, initialImageType } = useGetCondensedHeroImages();
  const image = useImageWithFallback<ImageType>(
    heroImageMap,
    initialImageType,
    'hero'
  );

  const isStockImage =
    image?.imageType === ImageType.JellyBean ||
    image?.imageType === ImageType.Generic;

  const { triggerSpinner, canClickImage } = useSpinnerWithAnalytics();

  const handlers = useSwipeTracking(triggerSpinner);

  if (!image?.url) return null;

  return (
    <>
      <Image
        alt={`${year} ${make} ${model} vehicle photo`}
        className={classNames(image.classes, {
          'cursor-pointer': canClickImage,
          'pointer-events-none select-none': !canClickImage
        })}
        decoding="async"
        draggable="false"
        loading="eager"
        src={image.url}
        wrapperClassName="h-full w-full"
        {...handlers}
      />
      {isStockImage && (
        <div className="absolute bottom-0 left-0 z-10 w-full pl-md text-left !text-[8px] text-text-disabled t-body-xs md:pb-sm md:!text-[10px]">
          ©Carvana, LLC stock image
        </div>
      )}
    </>
  );
}

export default memo(VehicleImage);
